// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1gHza","col":"Table_col__QTasF","fulfillmentStatus":"Table_fulfillmentStatus__2NeGX","emailCol":"Table_emailCol__2JYU8"};